module.exports = __webpack_public_path__ + "static/media/sidd_logo.18cc8418.jpeg";